import { useState, useEffect } from 'react'
import { showToast } from '@provi/provi-components'
import * as Sentry from '@sentry/browser'
import { uploadImages } from '../../../services/api'

export const useFrontSide = (goToNextScreen, creditPath, setIsLoading) => {
  const [filesNotUpload, setFilesNotUpload] = useState([])
  const [filesUploaded, setFilesUploaded] = useState([])
  const [isButtonDisabled, setIsButtonDisabled] = useState(true)
  const [preview, setPreview] = useState()
  const [numberOfFiles, setNumberOfFiles] = useState(0)
  const [numberOfFilesInitial, setNumberOfFilesInitial] = useState(0)

  useEffect(() => {
    if (creditPath && creditPath.ReadRGFrontSide && creditPath.ReadRGFrontSide.length > 0) {
      setIsButtonDisabled(false)
      setNumberOfFiles(creditPath.ReadRGFrontSide.length)
      setNumberOfFilesInitial(creditPath.ReadRGFrontSide.length)
      setFilesUploaded(creditPath.ReadRGFrontSide)
      setPreview(creditPath.ReadRGFrontSide[0])
    }
  }, [creditPath])

  useEffect(() => {
    if (filesNotUpload.length > 0) {
      setIsButtonDisabled(false)
    }
  }, [filesNotUpload])

  const onSubmit = async e => {
    e.preventDefault()
    setIsLoading(true)
    try {
      const urls = await uploadImages(filesNotUpload)
      const files = [...urls, ...filesUploaded]

      if (!files.length) {
        /**
         * An error happened with upload to firebase and returns empty array reseting the page to reset the state
         */
        setIsLoading(false)
        showToast('Ocorreu um erro ao enviar o arquivo. Tente novamente ou entre em contato com a Provi.')
        Sentry.captureException(new Error('onSubmit(RG front side): files is empty'))

        setTimeout(() => {
          window.location.reload()
        }, 3000)

        return
      } else {
        goToNextScreen(files)
      }
    } catch (e) {
      showToast()
    }
  }

  return [
    onSubmit,
    isButtonDisabled,
    numberOfFiles,
    preview,
    setPreview,
    setFilesNotUpload,
    filesNotUpload,
    setNumberOfFiles,
    numberOfFilesInitial
  ]
}
